// import { Link } from "@tanstack/react-router";
// import { useRestaurants } from "../../hooks/useRestaurants";
// import { menuRoute } from "../../App";

const HomePage = () => {
  // const { data: restaurants } = useRestaurants();
  return (
    <>
      <div className="h-screen w-full flex items-center justify-center bg-muted">
        <div className="bg-background flex flex-1 items-center justify-center rounded-lg m-8 p-8 shadow-sm max-w-[90%] sm:max-w-sm mx-auto my-auto">
          <div className="flex flex-col gap-1">
            <h3 className="text-2xl font-bold tracking-tight mb-2">
              TableTaxi
            </h3>
            <p>
              If you're at one of our locations, please try scanning the QR code
              again or contact the staff.
            </p>
            <br />
            <p>
              Want to learn more about our platform? Head over to{" "}
              <a href="https://table.taxi" className="underline">
                table.taxi
              </a>{" "}
              to learn more about our offerings.
            </p>
          </div>
        </div>
      </div>
      {/* {restaurants && (
        <div className="bg-background">
          <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
            <div className="sm:flex sm:items-baseline sm:justify-between">
              <h2 className="text-2xl font-bold tracking-tight text-foreground">
                All Restaurants
              </h2>
            </div>

            <div className="mt-6 grid grid-cols-1 gap-y-10 sm:grid-cols-3 sm:gap-x-6 sm:gap-y-0 lg:gap-x-8">
              {restaurants.map((restaurant) => (
                <div key={restaurant.id} className="group relative">
                  <div className="h-96 w-full overflow-hidden rounded-lg sm:aspect-h-3 sm:aspect-w-2 group-hover:opacity-75 sm:h-auto">
                    <img
                      src={`https://source.unsplash.com/400x400/?restaurant,${restaurant.id}`}
                      alt={restaurant.id}
                      className="h-full w-full object-cover object-center"
                    />
                  </div>
                  <h3 className="mt-4 text-base font-semibold text-foreground">
                    <Link to={menuRoute.to} params={{ menuId: restaurant.id }}>
                      <span className="absolute inset-0" />
                      {restaurant.name}
                    </Link>
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default HomePage;
